module.exports = __webpack_public_path__ + "static/henho1-5b3d096667ab75a6fa1c6500916d1d82.png";